import { Box, Grid, Typography } from '@mui/material';
import { Loading } from '@vabembarqueja/embarque-ja-shared-components';

import { useUserContext } from '../../contexts/User.context';
import { Colors } from '../../shared/colors';
import ConsumoPosPago from '../features/exibir-consumo-pos-pago/ConsumoPosPago';

const Extrato = () => {
  const { posPagoState, loading, orgaoPublico, statusAditivo } = useUserContext();

  if (loading) {
    return <Loading show bgColor={Colors.white} />;
  }
  return (
    <Grid container spacing={2} py={2}>
      <Grid item xs={12}>
        <Box height={40} display="flex" alignItems="center" justifyContent="space-between">
          <Typography
            data-tour-pj="postpaid-title"
            variant="h5"
            color={Colors.secondary}
            fontWeight={700}
          >
            Consumo pós-pago
          </Typography>
        </Box>
      </Grid>

      {posPagoState && (
        <ConsumoPosPago
          dataParaNovoPedido={posPagoState.dataParaNovoPedido}
          fases={posPagoState.fases}
          posPagoAtivo={posPagoState.posPagoAtivo}
          statusSolicitacao={posPagoState.solicitacao}
          orgaoPublico={orgaoPublico}
          statusAditivo={statusAditivo}
        />
      )}
    </Grid>
  );
};

export default Extrato;
